import { Box, Button, Container, Paper, styled, Tabs, Typography } from '@mui/material';

export const StyledContainer = styled(Container)(({ theme }) => ({
  backgroundColor: theme.palette.backgroundColorType3?.main || theme.palette.background.default,
  padding: '0px !important',
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: theme.spacing(1.5),
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
  backgroundColor: theme.palette.white?.main || '#FFFFFF',
  border: `1px solid ${theme.palette.neutral3?.main || '#E9E9E9'}`,
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: theme.palette.neutral2?.main || '#F2F2F2',
  borderRadius: theme.spacing(1.5),
  padding: theme.spacing(0.5),
  minHeight: 'auto',
  boxShadow: 'inset 0px 2px 4px rgba(0, 0, 0, 0.06)',
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '14px',
    minWidth: 'auto',
    minHeight: 'auto',
    padding: theme.spacing(1, 2.5),
    color: theme.palette.neutral7?.main || theme.palette.text.secondary,
    borderRadius: theme.spacing(1),
    marginRight: theme.spacing(0.5),
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '3px',
      backgroundColor: theme.palette.themeColor?.main,
      transform: 'scaleX(0)',
      transition: 'transform 0.3s ease',
    },
    '&:hover': {
      backgroundColor: theme.palette.white?.main,
      color: theme.palette.themeColor?.main,
      transform: 'translateY(-2px)',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
      '&::before': {
        transform: 'scaleX(0.5)',
      },
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.themeColor?.main,
      color: theme.palette.white?.main,
      boxShadow: '0px 6px 16px rgba(0, 85, 135, 0.25)',
      transform: 'translateY(-2px)',
      '&::before': {
        transform: 'scaleX(1)',
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
      },
      '& .MuiSvgIcon-root': {
        animation: 'pulse 2s ease-in-out infinite',
      },
    },
    '&:last-child': {
      marginRight: 0,
    },
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
      marginRight: theme.spacing(0.5),
    },
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    gap: theme.spacing(0.5),
  },
  '@keyframes pulse': {
    '0%, 100%': {
      opacity: 1,
      transform: 'scale(1)',
    },
    '50%': {
      opacity: 0.8,
      transform: 'scale(1.05)',
    },
  },
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 500,
  padding: theme.spacing(0.75, 2.5),
  borderRadius: theme.spacing(0.5),
  boxShadow: 'none',
  '&:hover': {
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  },
}));

export const PaginationWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: theme.spacing(2),
  gap: theme.spacing(1.5),
}));

export const NoteText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
  fontSize: '12px',
  color: theme.palette.neutral6?.main || theme.palette.text.secondary,
  fontStyle: 'italic',
}));

export const FilterPanel = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutral1?.main || '#F6F7FB',
  padding: '4px',
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.neutral3?.main || '#E9E9E9'}`,
}));

export const FilterRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
  flexWrap: 'wrap',
  alignItems: 'flex-start',
}));

export const TabsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}));

export const TabIndicator = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 2),
  background: `linear-gradient(135deg, ${
    theme.palette.backgroundColorType3?.main || '#F7F8FA'
  } 0%, ${theme.palette.white?.main || '#FFFFFF'} 100%)`,
  borderRadius: theme.spacing(1.5),
  fontSize: '13px',
  color: theme.palette.neutral7?.main,
  border: `1px solid ${theme.palette.neutral3?.main || '#E9E9E9'}`,
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    transform: 'translateY(-1px)',
  },
}));
